
import { smeSessionStart , smeSessionEnd} from "../../api/user"

const MenuList = ({item,collapseNav,changeRender360Map,setModalPopupContent}) => {


    const dropdownLiChange = (e,obj) => {

        // document.querySelectorAll('.dropdown_item').forEach(element => {
        //     element.style.color = "#4e4e4e"
        // })
        // e.target.style.color = obj.color

        if(obj.key === "sme_add_participant") {

            setModalPopupContent(obj.key)
            return;
        }  

        if(obj.key === "sme_start_session") {

            //sme Session started
            let reqData = {} 
            let user_id = sessionStorage.getItem("user_id");
            if(user_id) {
                reqData.sme_id = user_id
                reqData.name = "session"

                smeSessionStart(reqData).then((val) => {
                    if(val.data.response === "success") {
                        sessionStorage.removeItem("session_id");
                        sessionStorage.setItem("session_id",val.data.data.id);
                        alert("Session started")
                    }           
                
                })

            }

            return;
        }  
        if(obj.key === "sme_end_session") {

            //sme Session started
            let reqData = {} 
            let session_id = sessionStorage.getItem("session_id");
            if(session_id) {
                reqData.session_id = session_id
                smeSessionEnd(reqData).then((val) => {

                    if(val.data.response === "success") {

                        sessionStorage.removeItem("session_id");
                        alert("Session ended")
                    }
             

                })

            }

            return;
        }  


       // alert(obj.key)
        changeRender360Map(obj.key)

    }


    return(
        <li key={item.label}>
            <a href="#" className={item.class} id={item.key} onClick={(e) => {collapseNav(e,item.key)} } data-colortype={item.color} >{item.label}</a>

            {
            item.subArr && 
                <ul className="submenu">

                    {
                        item.subArr.map(sub => {
                            
                            return (
                                <li key={sub.label}><a className="dropdown_item" id={sub.id} href="#" onClick={(e) =>{
                                    
                                    dropdownLiChange(e,sub)
                                }
                                } >{sub.label}</a></li>
                            )

                        })
                    }
                </ul>
        
            }
            
        </li>
    )
}


export default MenuList